import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.526 20.767c-.412.313-.605.84-.496 1.35.11.51.502.908 1.005 1.02a1.305 1.305 0 001.331-.503l5.258-5.334a1.347 1.347 0 000-1.866L10.366 10.1a1.3 1.3 0 00-1.718.124 1.348 1.348 0 00-.122 1.743l4.312 4.4-4.338 4.4h.026z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.526 20.767c-.412.313-.605.84-.496 1.35.11.51.502.908 1.005 1.02a1.305 1.305 0 001.331-.503l5.258-5.334a1.347 1.347 0 000-1.866L18.366 10.1a1.3 1.3 0 00-1.718.124 1.347 1.347 0 00-.122 1.743l4.311 4.4-4.337 4.4h.026z",
      fill: "#fff"
    }
  )
);
export {
  l as default
};
